'use strict';

angular.module('uniromaLandingApp')
    .controller('RejectedTypeController', 
    		['$scope', 'RejectedType', 'ParseLinks',function ($scope, RejectedType, ParseLinks) {
        $scope.rejectedTypes = [];
        $scope.page = 0;
        $scope.loadAll = function() {
            RejectedType.query({page: $scope.page, size: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.rejectedTypes = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            RejectedType.get({id: id}, function(result) {
                $scope.rejectedType = result;
                $('#deleteRejectedTypeConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            RejectedType.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteRejectedTypeConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.rejectedType = {
                name: null,
                description: null,
                id: null
            };
        };
    }]);
